/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import ProgressIndicator from './ProgressIndicator';

class PasswordStrengthMeter extends React.Component {

  getPasswordStrengthMessage(strength) {
    switch (strength) {
      case 0:
        return 'pwd-strength.score-0.label';
      case 1:
        return 'pwd-strength.score-1.label';
      case 2:
        return 'pwd-strength.score-2.label';
      case 3:
        return 'pwd-strength.score-3.label';
      case 4:
        return 'pwd-strength.score-4.label';
      default:
        return 'pwd-strength.no-score.label';
    }
  }

  render() {
    return (
      <ProgressIndicator
        title={<FormattedMessage id={this.getPasswordStrengthMessage(this.props.value)} />}
        value={this.props.value}
        hasBackground
        maxValue={4}
        styleSteps={[
          {
            minValue: 0,
            colorClassName: '',
          },
          {
            minValue: 1,
            colorClassName: 'bkgd-color-poor',
          },
          {
            minValue: 2,
            colorClassName: 'bkgd-color-weak',
          },
          {
            minValue: 3,
            colorClassName: 'bkgd-color-good',
          },
          {
            minValue: 4,
            colorClassName: 'bkgd-color-strong',
          },
        ]}
      />
    );
  }
}
PasswordStrengthMeter.propTypes = {
  value: PropTypes.number.isRequired,
};

export default PasswordStrengthMeter;
